import { SortConfig } from 'store/types/Table';
import { Attendee } from 'store/types/Meeting';
import { sorter } from 'util/table';

export enum VotingTableActionType {
  SetInitialList = 'SetInitialList',
  UpdateSort = 'UpdateSort',
}

export interface VotingTableState {
  initialList: Attendee[];
  list: Attendee[];
  sort: SortConfig<Attendee>;
}

export interface VotingTableAction {
  type: VotingTableActionType;
  payload: Partial<VotingTableState>;
}

const getSortedList = (list: Attendee[] = [], sort: SortConfig<Attendee>): Attendee[] =>
  list.length ? [...list].sort(sorter<Attendee>(sort)) : [...list];

export const initialState: VotingTableState = {
  initialList: [],
  list: [],
  sort: { column: 'company', direction: 'asc' },
};

const reducer = (state: VotingTableState, { type, payload }: VotingTableAction): VotingTableState => {
  if (type === VotingTableActionType.SetInitialList) {
    const { initialList = [] } = payload;
    const list = getSortedList(initialList ?? [], state.sort);

    return { ...state, initialList, list };
  }

  if (type === VotingTableActionType.UpdateSort) {
    const { sort = {} } = payload;

    return {
      ...state,
      sort,
      list: getSortedList(state.initialList, sort),
    };
  }

  return state;
};

export default reducer;
